module.exports = __webpack_public_path__ + "static/img/user.6d81db6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.jpg
// module id = BQ5I
// module chunks = 1